// extracted by mini-css-extract-plugin
export default {"wrapper":"landscapeOverlay__wrapper__Xlyvn","phoneIcon":"landscapeOverlay__phoneIcon__YSQB_","phoneRotate":"landscapeOverlay__phoneRotate__E5c_a"};